import logoWhiteLogistician from "@/assets/logoWithName-white-color-logistician.svg";
import logoWhiteMerchant from "@/assets/logoWithName-white-color-merchant.svg";
import logoWhiteOther from "@/assets/logoWithName-white-color-other.svg";
import logoWitheStore from "@/assets/logoWithName-white-color-store.svg";
import useViewerRole from "@/lib/rights/use-viewer-role.ts";

export default function SidebarLogo() {
  const role = useViewerRole();

  if (!role) return null;

  const logo = {
    owner: logoWhiteMerchant,
    admin: logoWhiteMerchant,
    store: logoWitheStore,
    customersupport: logoWhiteOther,
    logistician: logoWhiteLogistician,
  }[role];

  return (
    <div className="py-2">
      <img className="h-8 w-auto" src={logo} alt="Workflow" />
    </div>
  );
}
